import { entityOutlineColor, entityOutlineWidth } from "./entity_style";

export function drawProjectile(
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number,
  direction: { x: number; y: number } | null | undefined
): void {
  const angle = projectileAngle(direction);
  const fillColor = "#ef4444";
  const outlineColor = entityOutlineColor(fillColor);
  const strokeWidth = entityOutlineWidth(radius * 1.35);

  context.save();
  context.translate(x, y);
  context.rotate(angle);

  buildProjectilePath(context, radius);
  context.fillStyle = fillColor;
  context.fill();

  context.save();
  buildProjectilePath(context, radius);
  context.clip();

  const shade = context.createLinearGradient(-radius * 1.05, 0, radius * 1.55, 0);
  shade.addColorStop(0, "rgba(127,29,29,0.28)");
  shade.addColorStop(0.48, "rgba(127,29,29,0)");
  shade.addColorStop(1, "rgba(255,255,255,0.18)");
  context.fillStyle = shade;
  context.fillRect(-radius * 1.2, -radius, radius * 2.9, radius * 2);

  context.save();
  context.rotate(-angle);
  context.beginPath();
  context.ellipse(
    -radius * 0.22,
    -radius * 0.18,
    radius * 0.42,
    radius * 0.16,
    -0.18,
    0,
    Math.PI * 2
  );
  context.fillStyle = "rgba(255,255,255,0.3)";
  context.fill();
  context.restore();

  context.restore();

  buildProjectilePath(context, radius);
  context.strokeStyle = outlineColor;
  context.lineWidth = strokeWidth;
  context.lineJoin = "round";
  context.lineCap = "round";
  context.stroke();

  context.restore();
}

export function drawOrbitingBall(
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number
): void {
  const fillColor = "#22c55e";

  context.save();

  context.beginPath();
  context.arc(x, y, radius, 0, Math.PI * 2);
  context.fillStyle = fillColor;
  context.fill();
  context.strokeStyle = entityOutlineColor(fillColor);
  context.lineWidth = entityOutlineWidth(radius);
  context.stroke();

  context.beginPath();
  context.arc(x - radius * 0.24, y - radius * 0.26, radius * 0.36, 0, Math.PI * 2);
  context.fillStyle = "rgba(255,255,255,0.22)";
  context.fill();

  context.restore();
}

export function drawDamageZone(
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number
): void {
  context.save();

  context.beginPath();
  context.arc(x, y, radius, 0, Math.PI * 2);
  context.fillStyle = "rgba(207, 34, 46, 0.14)";
  context.fill();
  context.strokeStyle = "rgba(207, 34, 46, 0.38)";
  context.lineWidth = entityOutlineWidth(radius) * 0.72;
  context.setLineDash([10, 8]);
  context.stroke();

  context.restore();
}

function buildProjectilePath(context: CanvasRenderingContext2D, radius: number): void {
  context.beginPath();
  context.moveTo(radius * 1.55, 0);
  context.lineTo(-radius * 1.0, -radius * 0.82);
  context.quadraticCurveTo(-radius * 0.68, 0, -radius * 1.0, radius * 0.82);
  context.closePath();
}

function projectileAngle(direction: { x: number; y: number } | null | undefined): number {
  if (!direction) {
    return 0;
  }

  if (!Number.isFinite(direction.x) || !Number.isFinite(direction.y)) {
    return 0;
  }

  if (Math.hypot(direction.x, direction.y) <= 0.0001) {
    return 0;
  }

  return Math.atan2(direction.y, direction.x);
}